/**
 * MealScheduleStep.validation.js
 *
 * Pure function, no React — mirrors FoodPreferencesStep.validation.js.
 * Breakfast/Lunch/Dinner are required (non-empty time strings); Bedtime,
 * Number of Meals, and Fasting Window are all optional per the FSD.
 */

const TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d)$/;

function isValidTime(value) {
  return typeof value === "string" && TIME_PATTERN.test(value);
}

export function validateMealSchedule(data) {
  const errors = {};

  if (!isValidTime(data.breakfast)) {
    errors.breakfast = "Please set a breakfast time.";
  }
  if (!isValidTime(data.lunch)) {
    errors.lunch = "Please set a lunch time.";
  }
  if (!isValidTime(data.dinner)) {
    errors.dinner = "Please set a dinner time.";
  }
  // Bedtime is optional, but if it's provided it still has to be a real
  // time value rather than a partial/garbage string from the picker.
  if (data.bedtime && !isValidTime(data.bedtime)) {
    errors.bedtime = "Please enter a valid bedtime.";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}
